import { useEffect } from 'react';
import { ScheduleDefaults } from '@frontend/api-schedule';
import { ScheduleV2 } from '@frontend/api-schedule-v2';
import { getFullName } from '@frontend/name';
import { CustomContact } from './CustomContact';
import { PersonNotesComponent } from './PersonNotesComponent';
import { PersonSearch } from './PersonSearch';
import { useManagePersonListContext } from './PersonSelectorContext';
import { PatientSelectorScreenEnum } from './types';

export const PersonListContainer = () => {
  const { personSelectorScreen, shouldRenderNotes, setPersonSelectorScreen } = useManagePersonListContext();

  useEffect(() => {
    return () => {
      setPersonSelectorScreen(PatientSelectorScreenEnum.PERSON_SEARCH);
    };
  }, []);

  return (
    <>
      {personSelectorScreen === PatientSelectorScreenEnum.PERSON_SEARCH && <PersonSearch />}
      {personSelectorScreen === PatientSelectorScreenEnum.PERSON_NOTES && shouldRenderNotes && <PersonNotes />}
      {personSelectorScreen === PatientSelectorScreenEnum.CUSTOM_CONTACT && <CustomContact />}
    </>
  );
};

const PersonNotes = () => {
  const { isLoading, selectedPerson, locationId, closePopoverDialog, onAddToListHandler, addToListButtonTrackingId } =
    useManagePersonListContext();

  const handleAddToList = (note: string) => {
    if (selectedPerson && onAddToListHandler) {
      onAddToListHandler({
        personId: selectedPerson.PersonID,
        notes: note,
        isNew: !quickFillRecipient?.personId,
      });
    }
  };

  const { data: quickFillRecipient, isLoading: isLoadingQuickFillRecipient } = ScheduleV2.Queries.useEntryQuery({
    request: {
      personId: selectedPerson?.PersonID ?? '',
    },
    httpOptions: {
      headers: {
        [ScheduleDefaults.LOCATION_ID_HEADER]: locationId,
      },
    },
    options: {
      enabled: !!selectedPerson?.PersonID && !!locationId,
      cacheTime: 0,
      staleTime: 0,
      retry: false,
      useErrorBoundary: false,
    },
  });

  return (
    <PersonNotesComponent
      isLoading={isLoading || isLoadingQuickFillRecipient}
      note={quickFillRecipient?.note || ''}
      heading={selectedPerson ? getFullName(selectedPerson) : ''}
      primaryButtonTrackingId={addToListButtonTrackingId}
      onPrimaryClick={handleAddToList}
      onSecondaryClick={closePopoverDialog}
    />
  );
};
